import { render, staticRenderFns } from "./shareQrCentre.vue?vue&type=template&id=6910afdb&scoped=true"
import script from "./shareQrCentre.vue?vue&type=script&lang=js"
export * from "./shareQrCentre.vue?vue&type=script&lang=js"
import style0 from "./shareQrCentre.vue?vue&type=style&index=0&id=6910afdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910afdb",
  null
  
)

export default component.exports